<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid, dirty }"
  >
    <div
      class="baselineData"
    >
      <div
        class="baselineData__subtitle"
      >
        <v-icon
          color="primary"
        >
          mdi-calendar
        </v-icon>
        {{ $t('massBalance.periodOfTheBaseline') }}
      </div>
      <VSelect
        v-model="baselineData.period"
        :label="$t('forms.labels.period')"
        :items="periodList"
        outlined
        :rules="{ required: true }"
        @change="onInput"
      />

      <v-row>
        <v-col>
          <VTextField
            v-model.number="baselineData.baselineYear"
            :label="$t('massBalance.e4Form.labels.baselineYear')"
            type="text"
            outlined
            maxlength="4"
            :rules="{ required: true }"
            @change="onInput"
          />
        </v-col>
        <v-col>
          <VSelect
            v-model="baselineData.startMonth"
            :label="$t('massBalance.startMonth')"
            :items="monthsList"
            outlined
            :disabled="baselineData.period === 'annual'"
            :rules="{ required: true }"
            @change="onInput"
          />
        </v-col>
      </v-row>
      <div
        class="baselineData__subtitle"
      >
        {{ $t('massBalance.optionToProvideTheWaterSavingsBaseline') }}
      </div>
      <div>
        <v-radio-group
          v-model="baselineData.waterSavingBaselineOption"
          row
          @change="onInput"
        >
          <v-radio
            v-for="option in waterSavingsBaselineOptionList"
            :key="option.id"
            :label="$t(`massBalance.e4Form.baselineData.options.${option.id}`)"
            :value="option.id"
            :rules="{ required: true }"
            @change="onInput"
          />
        </v-radio-group>
      </div>

      <v-container
        v-if="baselineData.waterSavingBaselineOption"
        style="padding: 0px;"
        fluid
        fillWidth
      >
        <v-table
          height="300px"
          fixedHeader
          class="baselineData__table"
        >
          <thead>
            <tr
              style="background-color:#26384B; color: white; height: 40px;"
            >
              <th
                width="200"
                style="font-weight: 400; text-align: left; padding-left: 10px; border-right: 1px solid white;"
              >
                {{ $t('massBalance.savings') }}
              </th>
              <th
                width="900"
                style="font-weight: 400;"
              >
                {{ $t('massBalance.waterSavingsBaseline') }}
              </th>
            </tr>
          </thead>
        </v-table>
      </v-container>
      <!--  le  tableau de données en dessous du masterTitre -->
      <v-container
        v-if="baselineData.waterSavingBaselineOption"

        style="padding: 0px;"
        fluid
        fillWidth
      >
        <v-table
          height="300"
          fixedHeader
          class="baselineData__table"
          style="overflow-y: auto;"
        >
          <thead>
            <tr
              style="height: 50px;"
            >
              <th
                width="200"
                style="font-weight: 400; text-align: left; padding-left: 10px; border-right: 1px solid white; "
                class="baselineData__table__cell"
              />
              <th
                width="450"
                class="baselineData__table__cell"
              >
                {{ firstColumnTitle() }}
              </th>
              <th
                width="450"
                class="baselineData__table__cell"
              >
                {{ secondColumnTitle() }}
              </th>
            </tr>
          </thead>
          <tbody
            style="max-height: 50px !important;"
          >
            <tr>
              <td
                class="baselineData__table__cell"
              >
                {{ $t('massBalance.reportUnit') }}
              </td>
              <td>
                <div
                  style="width: 30%; display: inline-block;"
                >
                  <VSelect
                    v-model="baselineData.reportUnit.firstColumn"
                    :items="waterSavingsReportUnits"
                    :outlined="false"
                    :rules="{ required: true }"
                    @change="onInput"
                  />
                </div>
              </td>
              <td>
                <div
                  style="width: 30%; display: inline-block;"
                >
                  <VSelect
                    v-model="baselineData.reportUnit.secondColumn"
                    :items="cycleBaselineList"
                    :outlined="false"
                    :disabled="baselineData.waterSavingBaselineOption === 'makeUpAndCycles'
                      || baselineData.waterSavingBaselineOption === 'blowdownAndCycles'"
                    :rules="{ required: true }"
                    @change="onInput"
                  />
                </div>
              </td>
            </tr>
            <tr
              v-for="(i, index) in baselineData.numberOfperiods"
              :key="i"
              style="text-align: center; "
            >
              <td
                style="font-weight: 400; text-align: left; padding-left: 10px; border-right: 1px solid white;"
                class="baselineData__table__cell"
              >
                {{ $t(`massBalance.e4Form.months.${baselineData.periodsMonths[index].startDate}`) }}
                {{ baselineData.period !== 'monthly' ? ` - ${$t(`massBalance.e4Form.months.${baselineData.periodsMonths[index].endDate}`)}` : '' }}
              </td>
              <td
                style="font-weight: 400; border:  0px 0px 1px 0px solid black"
              >
                <div
                  style="width: 30%; display: inline-block;"
                >
                  <VTextField
                    v-model.number="baselineData.periodsMonths[index].firstColumn"
                    :outlined="false"
                    :rules="{ required: true }"
                    @change="onInput"
                  />
                </div>
              </td>
              <td
                style="font-weight: 400; border: 0px 1px 0px 0px solid black"
              >
                <div
                  style="width: 30%; display: inline-block;"
                >
                  <VTextField
                    v-model.number="baselineData.periodsMonths[index].secondColumn"
                    :outlined="false"
                    :rules="{ required: true }"
                    @change="onInput"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-container>
    </div>


    <SlotScopeWatcher
      :value="dirty"
      @change="$emit('dirty-changed', dirty)"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('valid-changed', valid)"
    />
  </ValidationObserver>
</template>

<script>
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import { ValidationObserver } from 'vee-validate';
import { BASELINE_DATA_PERIODS, WATER_SAVINGS_BASELINE_OPTIONS, WATER_SAVING_REPORT_UNITS } from '@/aquassist-shared/constants/massBalance';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { MONTHS } from '@/aquassist-shared/constants/dates';
import { mapActions, mapGetters } from 'vuex';


export default {
    name: 'BaselineData',
    components: {
        ValidationObserver,
        SlotScopeWatcher,
        VSelect,
        VTextField,
    },
    props: {
        editMode: {
            type: Boolean,
            default: false,
        },

    },
    data() {
        return {
            baselineData: {
                period: null,
                baselineYear: null,
                startMonth: null,
                waterSavingBaselineOption: null,
                reportUnit: {
                    firstColumn: null,
                    cycleBaseline: null,
                },
                // temporary
                periodsMonths: [],
                numberOfperiods: 0,
            },
            isInitialized: false,
        };
    },
    computed: {
        ...mapGetters(['e4Config']),

        periodList() {
            const periodList = BASELINE_DATA_PERIODS.map(value => ({ id: value, name: this.$t(`massBalance.e4Form.periodicities.${value}`) }));
            return periodList;
        },
        monthsList() {
            const periodList = MONTHS.map(value => ({ id: value, name: this.$t(`massBalance.e4Form.months.${value}`) }));
            return periodList;
        },
        waterSavingsBaselineOptionList() {
            return WATER_SAVINGS_BASELINE_OPTIONS.map(value => ({ id: value, name: this.$t(`massBalance.e4Form.baselineData.options.${value}`) }));
        },
        waterSavingsReportUnits() {
            return WATER_SAVING_REPORT_UNITS.map(value => ({ id: value, name: value }));
        },
        cycleBaselineList() {
            if (this.baselineData.waterSavingBaselineOption === 'makeUpAndCycles' || this.baselineData.waterSavingBaselineOption === 'blowdownAndCycles') {
                return [{ id: 'cycle', name: this.$t('massBalance.sectionWO.cycles') }];
            } if (this.baselineData.waterSavingBaselineOption === 'makeUpAndBlowdown') {
                return WATER_SAVING_REPORT_UNITS.map(value => ({ id: value, name: value }));
            }
            return [];
        },
    },
    watch: {
        'baselineData.period': {
            deep: true,
            async handler() {
                await this.defineNumberOfPeriods();
                await this.definePeriods();
            },
        },
        'baselineData.startMonth': {
            handler() {
                this.definePeriods();
            },
        },
        'baselineData.waterSavingBaselineOption': {
            handler() {
                if (this.baselineData.waterSavingBaselineOption === 'makeUpAndCycles' || this.baselineData.waterSavingBaselineOption === 'blowdownAndCycles') {
                    this.baselineData.reportUnit.secondColumn = 'cycle';
                }
            },
        },
    },
    async created() {
        if (this.editMode) {
            this.baselineData = { ...this.e4Config.baselineData } || {};
            await this.defineNumberOfPeriods();
            await this.definePeriods();
        }
        this.isInitialized = true;
        await this.onInput();
    },
    methods: {
        ...mapActions({
            setE4Config: 'setE4Config',
        }),
        // en fonction du mois de départ et de la périodicité
        // Cette fonction permet de définir les mois début et fin de chaque periode
        // Pour la colonne de gauche
        definePeriods() {
            if (!this.baselineData.startMonth || !this.baselineData.period) {
                this.baselineData.periodsMonths = [];
                return;
            }

            // Trouver l'index du mois de départ
            const startMonthIndex = MONTHS.indexOf(this.baselineData.startMonth);
            if (startMonthIndex === -1) {
                this.baselineData.periodsMonths = [];
                return;
            }

            const monthsPerPeriod = 12 / this.baselineData.numberOfperiods;
            this.baselineData.periodsMonths = [];

            for (let i = 0; i < this.baselineData.numberOfperiods; i += 1) {
                const startIndex = (startMonthIndex + i * monthsPerPeriod) % 12;
                const endIndex = (startIndex + monthsPerPeriod - 1) % 12;

                this.baselineData.periodsMonths.push({
                    startDate: MONTHS[startIndex],
                    endDate: MONTHS[endIndex],
                    firstColumn: this.e4Config.baselineData.periodsMonths[i] ? this.e4Config.baselineData.periodsMonths[i].firstColumn : null,
                    secondColumn: this.e4Config.baselineData.periodsMonths[i] ? this.e4Config.baselineData.periodsMonths[i].secondColumn : null,
                });
            }
        },
        defineNumberOfPeriods() {
            // Si la périod est annuelle, mettre le mois de départ à janvier (et griser ce champ)
            if (this.baselineData.period === 'annual') {
                this.baselineData.startMonth = 'january';
            }

            // Mettre à jour le nombre de periodes pour préparer le tableau
            switch (this.baselineData.period) {
                case 'monthly':
                    this.baselineData.numberOfperiods = 12;
                    break;
                case 'quarterly':
                    this.baselineData.numberOfperiods = 4;
                    break;
                case 'semiannual':
                    this.baselineData.numberOfperiods = 2;
                    break;
                case 'annual':
                    this.baselineData.numberOfperiods = 1;
                    break;
                default:
                    this.baselineData.numberOfperiods = 0;
                    break;
            }
        },
        firstColumnTitle() {
            switch (this.baselineData.waterSavingBaselineOption) {
                case 'makeUpAndCycles':
                    return this.$t('massBalance.makeUpBaseline');
                case 'blowdownAndCycles':
                    return this.$t('massBalance.blowdownBaseline');
                case 'makeUpAndBlowdown':
                    return this.$t('massBalance.makeUpBaseline');
                default:
                    return '';
            }
        },
        secondColumnTitle() {
            switch (this.baselineData.waterSavingBaselineOption) {
                /*  TODO METTRE LES TRADUCTIONS */
                case 'makeUpAndCycles':
                    return this.$t('massBalance.cycleBaseline');
                case 'blowdownAndCycles':
                    return this.$t('massBalance.cycleBaseline');
                case 'makeUpAndBlowdown':
                    return this.$t('massBalance.blowdownBaseline');
                default:
                    return '';
            }
        },
        async onInput() {
            if (this.isInitialized) {
                this.setE4Config({ baselineData: this.baselineData });
            }
        },
    },
};
</script>

<style lang="scss">

.baselineData {

  &__subtitle {
    margin-top: 10px;
    color: #26384B;
    font-weight: bold;
    margin-bottom: 20px;
  }
  &__table {
    min-width: 100% !important;
    width: 100% !important;
    display: block;
    border-collapse: collapse;
    table-layout: fixed !important;
    .v-select__selection {
      text-align: center !important;
      width: 100% ;
    }
    input {
      text-align: center !important;
    }
    td {
      border: 1px solid black;
      text-align: center;
    }
    &__cell {
      border: 1px solid black !important;
      border-collapse: collapse !important;
      padding: 10px !important;
      text-align: center !important;
      color: #26384B;
      font-weight: 600 !important;
    }
  }
}

.textAlign input {
  text-align: center;
}

</style>
